import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import "./AnnotationModal.scss";

const AnnotationContainer = ({
  selectedText,
  showModal,
  handleClose,
  handleNewAnnotation,
}) => {
  const [annotationText, setAnnotationText] = useState("");
  const [selectedColor, setSelectedColor] = useState("#ffd700");

  const handleSaveAnnotation = () => {
    handleNewAnnotation(selectedText, annotationText, selectedColor);
    handleClose();
  };

  if (!showModal) return null;

  return (
    <div className="annotation-container">
      <div className="container-header">
        <span>New Annotation: "{selectedText}"</span>
        <Button variant="link" onClick={handleClose}>
          <span>CLOSE</span>
          <i className="fa fa-times close-icon" aria-hidden="true"></i>
          {/* This will represent the close icon */}
        </Button>
      </div>
      <div className="container-body">
        <Form>
          <Form.Group className="color-picker-group" controlId="highlightColor">
            <Form.Label>Highlight Color</Form.Label>
            <Form.Control
              type="color"
              value={selectedColor}
              onChange={(e) => setSelectedColor(e.target.value)}
            />
          </Form.Group>
          <Form.Group controlId="annotationText">
            <Form.Control
              as="textarea"
              rows={3}
              value={annotationText}
              placeholder="Focus on this"
              onChange={(e) => setAnnotationText(e.target.value)}
            />
          </Form.Group>
        </Form>
      </div>
      <div className="container-footer">
        <Button variant="primary" onClick={handleSaveAnnotation}>
          Save
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default AnnotationContainer;
